import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/bod", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/bod/csv", params);
};

const upsert = data => {
  return restApi.post("/api/bod/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/bod/${ids}`);
};

const getLookup = () => {
  return restApi.get("/api/bod/lookup");
};

const BODService = {
  getAll,
  getAllForCSV,
  upsert,
  remove,
  getLookup
};

export default BODService;